import { Component, effect, inject, input, model, signal } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { NotificationGetModel } from "../../models/notification-get.model";
import { CommonModule } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";
import { NotificationTypeIconPipe } from "../../pipes/notification-type-icon.pipe";
import { NotificationTypeIconBackgroundPipe } from "../../pipes/notification-type-icon-background.pipe";
import { NotificationApiService } from "../../services/notification.api.service";
import { AppDatePipe } from "../../../core/pipes/app-date.pipe";

@Component({
    selector: "app-notification-details-modal",
    templateUrl: "./notification-details-modal.component.html",
    styleUrl: "./notification-details-modal.component.scss",
    imports: [
        CommonModule,
        TranslatePipe,
        AppDatePipe,
        NotificationTypeIconPipe,
        NotificationTypeIconBackgroundPipe
    ]
})
export class NotificationDetailsModalComponent {
    private readonly notificationApiService = inject(NotificationApiService);
    private readonly sanitizer = inject(DomSanitizer);

    public isOpen = model.required<boolean>();
    public notification = model.required<NotificationGetModel>();

    constructor() {
        effect(() => {
            if (this.isOpen() && !this.notification().seenByUser) {
                this.notificationApiService.markNotificationAsSeen(this.notification().id).subscribe((updatedNotification) => {
                    this.notification.set(updatedNotification);
                });
            }
        });
    }

    protected closeModal(): void {
        this.isOpen.set(false);
    }

    protected sanitizeHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}